import { render, staticRenderFns } from "./LoaderCubics.vue?vue&type=template&id=153e99d2&"
import script from "./LoaderCubics.vue?vue&type=script&lang=js&"
export * from "./LoaderCubics.vue?vue&type=script&lang=js&"
import style0 from "./loader.css?vue&type=style&index=0&lang=css&"
import style1 from "./loader-cubics.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports